/**
 * 工具名 → 中文显示名。
 *
 * 本文件从 CosmoClawToolGroup.vue 里原样抽出（那张 map 方法体一字未改），
 * 目的是让"过程 trace"这个新组件能与工具调用卡片共用同一份映射，
 * 而不是各存一份、日后各自漂移。
 *
 * 纯数据 + 纯函数，无副作用。
 */

const TOOL_NAME_MAP = {
  extract_document_text: '提取文档文本',
  extract_pdf_text: '提取PDF文本',
  extract_docx_text: '提取Word文本',
  renderDocx: '生成docx文档',
  renderDocxFromFile: '从文件生成docx',
  renderDocxFromFiles: '拼接文件生成docx',
  send_file: '发送文件',
  detect_file_type: '检测文件类型',
  write_file: '写入文件',
  edit_file: '编辑文件',
  web_search: '网络搜索',
  browser_use: '操控浏览器',
  delegateToAgent: '委托任务',
  delegateParallel: '并行委托',
  delegateAsync: '异步委托',
  taskOutput: '取回异步结果',
  listAvailableAgents: '列出可用Agent',
  setGoal: '设定目标',
  addGoalCriterion: '追加验收条件',
  completeGoal: '标记目标完成',
  getGoalStatus: '查看目标状态',
  create_cron_job: '创建定时任务',
  create_reminder: '创建定时提醒',
  create_report: '创建定时报告',
  list_cron_jobs: '列出定时任务',
  toggle_cron_job: '启停定时任务',
  delete_cron_job: '删除定时任务',
  listAvailableSkills: '列出可用技能',
  listSkillFiles: '列出技能文件',
  enable_tool: '激活扩展工具',
  record_lesson: '记录经验教训',
  readMateClawDoc: '读取平台文档',
  readSkillFile: '读取技能文件',
  execute_shell_command: '执行命令',
  getCurrentDateTime: '获取当前时间',
  getCurrentDate: '获取当前日期',
  load_skill: '加载技能',
  read_file: '读取文件',
  runSkillScript: '运行技能脚本',
  progress_update: '进度更新',
  list_files: '列出文件',
  search_file: '搜索文件',
  search_content: '搜索内容',
  web_fetch: '获取网页',
  ask_followup: '追问',
  list_workspace_memory_files: '列出工作区记忆文件',
  read_workspace_memory_file: '读取工作区记忆文件',
  write_workspace_memory_file: '写入工作区记忆文件',
  recall_structured: '结构化召回'
}

/** 取工具的原始名字（不同来源的字段名不一致，兼容三种）。 */
export function toolNameOf(tool) {
  if (!tool) return ''
  return tool.toolName || tool.content || ''
}

/** 工具名 → 中文显示名；没有映射时原样返回。 */
export function getToolDisplayName(toolOrName) {
  const name = typeof toolOrName === 'string' ? toolOrName : toolNameOf(toolOrName)
  return TOOL_NAME_MAP[name] || name
}

export { TOOL_NAME_MAP }
